module.exports = {
      id: "comm-automobile-usage",
      viewBox: "0 0 231.941 38.7",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-automobile",
      toString: function () {
        return this.url;
      }
    }